import { viewConstants } from './view.constants';

const INITIAL_STATE = { 
  isLoading: false,
  loadingModules: {} ,
  mainTitle: null,
  contextDropMenu: [],

  breadCrumb: [],
  activeTitle: ''

};

export function view(state = INITIAL_STATE, action) { 
  var loadingModulesCopy = {...state.loadingModules};

   switch (action.type) {

    
    case viewConstants.SET_CONTEXT_DROP_MENU:
 
      return {
        ...state,
        contextDropMenu: (action.contextDropMenu?action.contextDropMenu:[]) 
      }

    case viewConstants.SET_BREADCRUMB:

      return {
        ...state,
        breadCrumb: action.breadCrumb,
        activeTitle: action.activeTitle
        }

    case viewConstants.SET_MAIN_TITLE:
 
      return {
        ...state,
        mainTitle: action.mainTitle,
        contextDropMenu: (action.contextDropMenu?action.contextDropMenu:state.contextDropMenu) 
      }

    case viewConstants.IS_LOADING:
      if (action.module) {
        loadingModulesCopy[action.module] = true;
        return {
          ...state,
          loadingModules: loadingModulesCopy,
          isLoading: true
        };
      } else {
        return {
          ...state,
          isLoading: true,
          loadingModules: state.loadingModules
        }; 
    }  

    case viewConstants.IS_NOT_LOADING:
      if (action.module) {
        delete loadingModulesCopy[action.module];
        return {
          ...state,
          loadingModules: loadingModulesCopy,
          isLoading: (Object.keys(loadingModulesCopy).length>0) 
        };
      } else {
        return {
          ...state,
          isLoading: (Object.keys(loadingModulesCopy).length>0) ,
          loadingModules: state.loadingModules
        };
      };

    default:
      return state
  }
}

